export enum RESPONSE_MESSAGES {
  CanNotReadToken = "Cannot read properties of undefined (reading 'token')",
  Status500 = "Request failed with status code 500",
  Status401 = "Request failed with status code 401",
}
